import { getLocalStorageObject, getSessionStorageObject, setLocalStorageObject, setSessionStorageObject } from 'app-logic/storage'
import { delay } from '@xylabs/sdk-js'

export class InfoWrapper<T> {
  constructor(sessionName: string, value?: T, persistValues = false) {
    this._useLocalStorage = persistValues
    this._storageName = sessionName
    this._data = value ?? Object.create(null)
    this.load()
  }
  private _data: T
  private _storageName: string
  private _useLocalStorage: boolean
  public suggestedEmail?: string

  public get data() {
    return this._data
  }

  public getSanitizedData() {
    return this._data
  }

  public save() {
    const method = this._useLocalStorage ? setLocalStorageObject : setSessionStorageObject
    method(this._storageName, this._data)
    return this
  }

  public load() {
    const method = this._useLocalStorage ? getLocalStorageObject : getSessionStorageObject
    this._data = method(this._storageName)
    return this
  }

  public clear() {
    const method = this._useLocalStorage ? localStorage : sessionStorage
    method.removeItem(this._storageName)
    return this
  }

  public async valid() {
    return (await this.errors()).length === 0
  }

  public async errors() {
    await delay(0)
    return [] as Error[]
  }
}
